import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UNA from '../theme';

const datosAlumno = {
  grupos: [
    {
      id: 1,
      nombre: 'Python - Mayo 2026',
      tallerId: 1,
      titulo: 'Introducción a Python',
      instructor: 'Prof. Juan Mora',
      categoria: 'Programación',
      inicio: '2026-05-01',
      fin: '2026-06-30',
      progreso: 60,
      color: UNA.rojo,
      modulos: [
        { id: 1, titulo: 'Variables y tipos de datos', tipo: 'video', duracion: '25 min', completado: true },
        { id: 2, titulo: 'Estructuras de control', tipo: 'video', duracion: '30 min', completado: true },
        { id: 3, titulo: 'Ejercicio: Calculadora básica', tipo: 'ejercicio', duracion: '20 min', completado: false },
        { id: 4, titulo: 'Test del módulo 1', tipo: 'test', duracion: '15 min', completado: false },
      ]
    },
    {
      id: 2,
      nombre: 'Excel - Mayo 2026',
      tallerId: 2,
      titulo: 'Excel Avanzado',
      instructor: 'Prof. Carlos Vega',
      categoria: 'Ofimática',
      inicio: '2026-05-15',
      fin: '2026-06-15',
      progreso: 25,
      color: '#2e7d32',
      modulos: [
        { id: 1, titulo: 'Fórmulas avanzadas', tipo: 'video', duracion: '30 min', completado: true },
        { id: 2, titulo: 'Tablas dinámicas', tipo: 'video', duracion: '35 min', completado: false },
        { id: 3, titulo: 'Ejercicio práctico', tipo: 'ejercicio', duracion: '25 min', completado: false },
      ]
    }
  ]
};

const tipoColor = {
  video:     { bg: '#e8f5e9', color: '#2e7d32', label: '🎬 Video' },
  ejercicio: { bg: '#fff8e1', color: '#e65100', label: '✏️ Ejercicio' },
  test:      { bg: UNA.rojoClaro, color: UNA.rojo, label: '📝 Test' },
};

function BarraProgreso({ progreso }) {
  return (
    <div style={{ background: '#f0f0f0', borderRadius: '10px', height: '8px', width: '100%', overflow: 'hidden' }}>
      <div style={{ width: `${progreso}%`, height: '100%', background: UNA.rojo, borderRadius: '10px', transition: 'width 0.5s' }} />
    </div>
  );
}

function VistaGrupos({ grupos, onVerGrupo }) {
  return (
    <div>
      <h2 style={{ margin: '0 0 4px', fontSize: '1.6rem', color: UNA.texto }}>Mis grupos</h2>
      <p style={{ color: UNA.textoSuave, margin: '0 0 1.5rem' }}>Talleres en los que estás inscrito</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px,1fr))', gap: '1.25rem' }}>
        {grupos.map(g => (
          <div key={g.id}
            onClick={() => onVerGrupo(g)}
            style={{ background: 'white', borderRadius: '16px', overflow: 'hidden', cursor: 'pointer', boxShadow: '0 4px 10px rgba(0,0,0,0.07)', transition: 'transform 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
            <div style={{ height: '8px', background: g.color }} />
            <div style={{ padding: '1.25rem' }}>
              <span style={{ fontSize: '11px', background: UNA.rojoClaro, color: UNA.rojo, padding: '3px 10px', borderRadius: '12px', fontWeight: '600' }}>{g.categoria}</span>
              <h3 style={{ margin: '0.75rem 0 4px', fontSize: '16px', color: UNA.texto }}>{g.titulo}</h3>
              <p style={{ margin: '0 0 4px', fontSize: '13px', color: '#888' }}>{g.nombre}</p>
              <p style={{ margin: '0 0 1rem', fontSize: '13px', color: '#888' }}>👨‍🏫 {g.instructor}</p>
              <BarraProgreso progreso={g.progreso} />
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px', fontSize: '12px', color: '#aaa' }}>
                <span>{g.progreso}% completado</span>
                <span>📅 Hasta {g.fin}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function VistaContenido({ grupo, onVolver, onIrEncuesta }) {
  const [modulos, setModulos] = useState(grupo.modulos);

  const toggleCompletado = (id) => {
    setModulos(m => m.map(mod => mod.id === id ? { ...mod, completado: !mod.completado } : mod));
  };

  const completados = modulos.filter(m => m.completado).length;
  const progreso = Math.round((completados / modulos.length) * 100);
  const todoCompleto = completados === modulos.length;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
        <button onClick={onVolver}
          style={{ background: '#f0f0f0', border: 'none', color: '#444', padding: '8px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' }}>
          ← Volver
        </button>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.6rem', color: UNA.texto }}>{grupo.titulo}</h1>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#888' }}>{grupo.nombre} · 👨‍🏫 {grupo.instructor}</p>
        </div>
      </div>

      {/* Progreso */}
      <div style={{ background: 'white', borderRadius: '16px', padding: '1.5rem', marginBottom: '1.5rem', boxShadow: '0 4px 10px rgba(0,0,0,0.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
          <span style={{ fontWeight: '600', color: UNA.texto }}>Tu progreso</span>
          <span style={{ fontWeight: '700', color: UNA.rojo }}>{progreso}%</span>
        </div>
        <BarraProgreso progreso={progreso} />
        <p style={{ margin: '8px 0 0', fontSize: '13px', color: '#888' }}>{completados} de {modulos.length} módulos completados</p>
      </div>

      {/* Módulos */}
      <div style={{ background: 'white', borderRadius: '16px', padding: '1.5rem', boxShadow: '0 4px 10px rgba(0,0,0,0.06)', marginBottom: '1.5rem' }}>
        <h3 style={{ margin: '0 0 1rem', color: UNA.texto }}>Contenido del taller</h3>
        {modulos.map((m, i) => {
          const tipo = tipoColor[m.tipo];
          return (
            <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '14px 0', borderBottom: i < modulos.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: m.completado ? UNA.rojo : '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: m.completado ? 'white' : '#aaa', fontWeight: '700', fontSize: '13px' }}>
                {m.completado ? '✓' : i + 1}
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0, fontWeight: '500', color: m.completado ? '#aaa' : UNA.texto, textDecoration: m.completado ? 'line-through' : 'none' }}>{m.titulo}</p>
                <div style={{ display: 'flex', gap: '10px', marginTop: '4px' }}>
                  <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: tipo.bg, color: tipo.color, fontWeight: '600' }}>{tipo.label}</span>
                  <span style={{ fontSize: '12px', color: '#aaa' }}>⏱ {m.duracion}</span>
                </div>
              </div>
              <button onClick={() => toggleCompletado(m.id)}
                style={{ background: m.completado ? '#f0f0f0' : UNA.rojo, border: 'none', color: m.completado ? '#888' : 'white', padding: '7px 14px', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', flexShrink: 0 }}>
                {m.completado ? 'Desmarcar' : 'Completar'}
              </button>
            </div>
          );
        })}
      </div>

      {/* Encuesta */}
      {todoCompleto && (
        <div style={{ background: UNA.rojoClaro, border: `2px solid ${UNA.rojo}`, borderRadius: '16px', padding: '1.5rem', textAlign: 'center' }}>
          <p style={{ fontSize: '2rem', margin: '0 0 8px' }}>🎉</p>
          <h3 style={{ margin: '0 0 8px', color: UNA.rojo }}>¡Completaste el taller!</h3>
          <p style={{ color: '#888', margin: '0 0 1rem', fontSize: '14px' }}>Ayúdanos a mejorar completando la encuesta de valoración.</p>
          <button onClick={onIrEncuesta}
            style={{ background: UNA.rojo, border: 'none', color: 'white', padding: '12px 28px', borderRadius: '10px', cursor: 'pointer', fontWeight: '700', fontSize: '15px' }}
            onMouseEnter={e => e.target.style.background = UNA.rojoOscuro}
            onMouseLeave={e => e.target.style.background = UNA.rojo}>
            Completar encuesta →
          </button>
        </div>
      )}
    </div>
  );
}

function Encuesta({ grupo, onFinalizar }) {
  const preguntas = [
    '¿El contenido del taller fue claro y bien organizado?',
    '¿El instructor explicó los temas de forma comprensible?',
    '¿Los materiales y recursos fueron útiles?',
    '¿El tiempo asignado fue suficiente para el contenido?',
    '¿Recomendarías este taller a otros estudiantes?',
  ];
  const [respuestas, setRespuestas] = useState({});
  const [comentario, setComentario] = useState('');
  const [enviado, setEnviado] = useState(false);

  const responder = (i, valor) => setRespuestas(r => ({ ...r, [i]: valor }));
  const completo = preguntas.every((_, i) => respuestas[i]);

  if (enviado) {
    return (
      <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
        <p style={{ fontSize: '3rem', margin: '0 0 1rem' }}>✅</p>
        <h2 style={{ color: UNA.rojo, margin: '0 0 8px' }}>¡Gracias por tu valoración!</h2>
        <p style={{ color: '#888', marginBottom: '2rem' }}>Tu opinión nos ayuda a mejorar los talleres.</p>
        <button onClick={onFinalizar}
          style={{ background: UNA.rojo, border: 'none', color: 'white', padding: '12px 28px', borderRadius: '10px', cursor: 'pointer', fontWeight: '700' }}>
          Volver a mis grupos
        </button>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
        <button onClick={onFinalizar}
          style={{ background: '#f0f0f0', border: 'none', color: '#444', padding: '8px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' }}>
          ← Volver
        </button>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.6rem', color: UNA.texto }}>Encuesta de valoración</h1>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#888' }}>{grupo.titulo} · {grupo.nombre}</p>
        </div>
      </div>

      <div style={{ background: 'white', borderRadius: '16px', padding: '2rem', boxShadow: '0 4px 10px rgba(0,0,0,0.06)' }}>
        {preguntas.map((p, i) => (
          <div key={i} style={{ marginBottom: '2rem' }}>
            <p style={{ fontWeight: '500', color: UNA.texto, margin: '0 0 12px' }}>{i + 1}. {p}</p>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              {[1, 2, 3, 4, 5].map(val => (
                <button key={val} onClick={() => responder(i, val)}
                  style={{ width: '44px', height: '44px', borderRadius: '10px', border: respuestas[i] === val ? 'none' : '1.5px solid #ddd', background: respuestas[i] === val ? UNA.rojo : 'white', color: respuestas[i] === val ? 'white' : '#444', fontWeight: '700', cursor: 'pointer', fontSize: '16px', transition: '0.15s' }}>
                  {val}
                </button>
              ))}
              <span style={{ fontSize: '12px', color: '#aaa', marginLeft: '8px' }}>
                {respuestas[i] ? ['', 'Muy malo', 'Malo', 'Regular', 'Bueno', 'Excelente'][respuestas[i]] : ''}
              </span>
            </div>
          </div>
        ))}

        <div style={{ marginBottom: '2rem' }}>
          <p style={{ fontWeight: '500', color: UNA.texto, margin: '0 0 8px' }}>Comentarios adicionales (opcional)</p>
          <textarea value={comentario} onChange={e => setComentario(e.target.value)}
            placeholder="¿Qué mejorarías del taller?"
            rows={4}
            style={{ width: '100%', padding: '12px', border: '1.5px solid #ddd', borderRadius: '10px', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'Segoe UI, sans-serif' }}
            onFocus={e => e.target.style.borderColor = UNA.rojo}
            onBlur={e => e.target.style.borderColor = '#ddd'} />
        </div>

        <button onClick={() => setEnviado(true)}
          disabled={!completo}
          style={{ background: completo ? UNA.rojo : '#ddd', border: 'none', color: completo ? 'white' : '#aaa', padding: '13px 32px', borderRadius: '10px', cursor: completo ? 'pointer' : 'not-allowed', fontWeight: '700', fontSize: '15px' }}
          onMouseEnter={e => { if (completo) e.target.style.background = UNA.rojoOscuro; }}
          onMouseLeave={e => { if (completo) e.target.style.background = UNA.rojo; }}>
          Enviar valoración
        </button>
        {!completo && <p style={{ fontSize: '12px', color: '#aaa', marginTop: '8px' }}>Responde todas las preguntas para enviar.</p>}
      </div>
    </div>
  );
}

export default function Home() {
  const navigate = useNavigate();
  const { usuario, logout } = useAuth();
  const [vista, setVista] = useState('grupos');
  const [grupoActivo, setGrupoActivo] = useState(null);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ minHeight: '100vh', background: UNA.gris, fontFamily: 'Segoe UI, sans-serif' }}>

      {/* Navbar */}
<nav
  style={{
    background: UNA.rojo,
    padding: '0 2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '60px',
    position: 'sticky',
    top: 0,
    zIndex: 100
  }}
>

  {/* Logo + título */}
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }}
  >

    <img
      src={require('../assets/logo_una.jpg')}
      alt="Logo UNA"
      style={{
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        objectFit: 'cover',
        background: 'white',
        padding: '2px'
      }}
    />

    <span
      style={{
        color: 'white',
        fontWeight: '600',
        fontSize: '17px'
      }}
    >
      Talleres UNA · Campus Coto
    </span>
  </div>

  {/* Usuario */}
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '16px'
    }}
  >

    <span
      style={{
        color: 'rgba(255,255,255,0.85)',
        fontSize: '14px'
      }}
    >
      👋 {usuario?.nombre}
    </span>

    <button
      onClick={handleLogout}
      style={{
        background: 'rgba(255,255,255,0.15)',
        border: '1px solid rgba(255,255,255,0.3)',
        color: 'white',
        padding: '7px 16px',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: '500'
      }}
      onMouseEnter={e =>
        e.target.style.background =
          'rgba(255,255,255,0.25)'
      }
      onMouseLeave={e =>
        e.target.style.background =
          'rgba(255,255,255,0.15)'
      }
    >
      Cerrar sesión
    </button>

  </div>
</nav>

      {/* Contenido */}
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
        {vista === 'grupos' &&
          <VistaGrupos
            grupos={datosAlumno.grupos}
            onVerGrupo={(g) => { setGrupoActivo(g); setVista('contenido'); }} />}
        {vista === 'contenido' && grupoActivo &&
          <VistaContenido
            grupo={grupoActivo}
            onVolver={() => setVista('grupos')}
            onIrEncuesta={() => setVista('encuesta')} />}
        {vista === 'encuesta' && grupoActivo &&
          <Encuesta
            grupo={grupoActivo}
            onFinalizar={() => { setVista('grupos'); setGrupoActivo(null); }} />}
      </div>
    </div>
  );
}